<template>
  <div>
    <a-tabs v-if="isShow" class="goods_tabs" type="card" @change="callback">
      <a-tab-pane v-for="item in tabsList" :key="item.key" :tab="item.label">
        <component :is="item.component" :is-now-wa-customer.sync="isNowWaCustomer" :check-tab="checkTab"></component>
      </a-tab-pane>
  </a-tabs>
   <carriersSelectDialog ref="CarriersSelect" @select="handleSelect"></carriersSelectDialog>
  </div>
</template>

<script>
import activeIcon from '@/assets/img/icon_select.png'
import {postTrack} from '@/utils/point'
import {getConfig} from '@/pages/orderManage/api'
import carriersSelectDialog from '@/pages/orderManage/components/carriersSelectDialog.vue'
import inventory from './inventory/index.vue'
import expireWarning from './expireWarning/index.vue'

  export default {
    name:"InventoryManage",
    components:{
      carriersSelectDialog,
    },
    data(){
      return {
        activeIcon,
        checkTab:'inventory',
        tabsList: [
        {
          key: 'inventory',
          label: '库存查询',
          component: inventory,
        },
        {
          key: 'expireWarning',
          label: '临超期预警',
          component: expireWarning,
        }
      ],
      isNowWaCustomer: false,
      isShow: false,
      }
    },
    created(){
      postTrack('数据分析-库存管理-库存查询-按可用量')
      this.getConfigList()
    },
     mounted() {
      const {creditCode}=this.$store.state.user
      if(creditCode){
        this.$refs.CarriersSelect.init()
      }else{
        this.isShow = true;
      }
    },
    methods:{
      async getConfigList(){
        const res=await getConfig({
            appId: "1002",
            keys:['oms.nowwa.white.list']
        })
        const customerCode = this.$store.state.user?.customerCode
        const whiteList=res.configs[0]?.value?.split(',')||[];
        this.isNowWaCustomer = whiteList.includes(customerCode)
      },
      callback(value){
        this.checkTab=value;
        postTrack(`数据分析-库存管理-临超期预警-${this.tabsList.find(t=>t.key===value).label}`)
      },
      handleSelect(){
        this.isShow = true;
      }
    }
  }
</script>

<style lang="less" scoped>
.goods_tabs {
  /deep/.ant-tabs-bar{
    margin: 0;
    .ant-tabs-tab {
      height: 48px;
      width: 106px;
      line-height: 48px;
      text-align: center;
    }
  }
  /deep/.ant-tabs-nav-container {
    height: 48px !important;
  }
}
</style>
